import { IGenericModal, Modal } from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';

interface Props extends IGenericModal {
  onSubmit: () => void;
}

export const DeleteAuditFormModal = ({
  isOpen,
  onCancelClick,
  onSubmit
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      gridTemplateColumns="45%"
      isOpen={isOpen}
      onCancelClick={onCancelClick}
      headerTitle={t('administrationAuditsView.deleteAuditForm?')}
      mainButton={{
        action: onSubmit,
        variant: 'eucalyptus',
        label: t('common.yes')
      }}
      isSecondButtonVisible
    />
  );
};
